<template>
    <div>
        <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">工资拆分明细表</div>
        <el-row style="margin-top: 30px;">
            <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
                <el-tab-pane label="工资拆分现金明细表" name="GzcfxjMx">
                    <GzcfxjMx ref="GzcfxjMx" :from="from" v-show="!is_edit"></GzcfxjMx>
                </el-tab-pane>

                <el-tab-pane label="工资拆分银行卡明细表" name="GzcfyhkMx">
                    <GzcfyhkMx ref="GzcfyhkMx" :from="from" v-show="!is_edit"></GzcfyhkMx>
                </el-tab-pane>

                <el-tab-pane label="工资拆分银行卡待发明细表" name="GzcfyhkdfMx">
                    <GzcfyhkdfMx ref="GzcfyhkdfMx" :from="from" v-show="!is_edit"></GzcfyhkdfMx>
                </el-tab-pane>

                <el-tab-pane label="工资拆分五险明细表" name="GzcfwuMx">
                    <GzcfwuMx ref="GzcfwuMx" :from="from" v-show="!is_edit"></GzcfwuMx>
                </el-tab-pane>

                <el-tab-pane label="工资拆分代发明细表" name="GzcfdfMx">
                    <GzcfdfMx ref="GzcfdfMx" :from="from" v-show="!is_edit"></GzcfdfMx>
                </el-tab-pane>

                <el-tab-pane label="工资拆分代发公司明细表" name="GzcfdfgsMx">
                    <GzcfdfgsMx ref="GzcfdfgsMx" :from="from" v-show="!is_edit"></GzcfdfgsMx>
                </el-tab-pane>

            </el-tabs>
        </el-row>
    </div>
</template>

<script>
    
    import GzcfxjMx from "./tabs/GzcfxjMx.vue";
    import GzcfwuMx from "./tabs/GzcfwuMx.vue";
    import GzcfdfMx from "./tabs/GzcfdfMx.vue";
    import GzcfyhkMx from "./tabs/GzcfyhkMx.vue"
    import GzcfyhkdfMx from "./tabs/GzcfyhkdfMx.vue"
    import GzcfdfgsMx from "./tabs/GzcfdfgsMx.vue"
    export default {
        components: {
            GzcfxjMx:GzcfxjMx,
            GzcfwuMx:GzcfwuMx,
            GzcfdfMx:GzcfdfMx,
            GzcfyhkMx:GzcfyhkMx,
            GzcfyhkdfMx:GzcfyhkdfMx,
            GzcfdfgsMx:GzcfdfgsMx,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],
                is_edit: false,
                activeName: "GzcfxjMx",

                //页面相关
                dialogVisible: false,

               
            };
        },
        
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// GzcfMx.vue?4c2b8622